module.exports = __webpack_public_path__ + "static/media/ios-arrow-dropup.80a7e2b1.svg";